var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelaxed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F9F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_34296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 30.0011C50 41.0513 41.0492 50.0022 29.9989 50.0022C18.9487 50.0022 10 41.0492 10 30.0011C10 18.953 18.9508 10 30.0011 10C41.0513 10 50.0022 18.9508 50.0022 30.0011M48.0914 29.9837C48.0914 20.0092 39.9995 11.9173 30.0249 11.9173C20.0504 11.9173 11.9585 20.0092 11.9585 29.9837C11.9585 39.9583 20.0504 48.0502 30.0249 48.0502C39.9995 48.0502 48.0914 39.9583 48.0914 29.9837Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9909 21.9178C24.3789 21.7855 25.6846 22.7029 26.9078 24.6787C27.1464 25.0669 27.1225 25.4313 26.8167 25.7696C26.7083 25.9019 26.602 25.9844 26.4936 26.0169C25.8581 26.2143 25.4026 26.0993 25.1467 25.6699C24.4028 24.4228 23.6849 23.8025 22.9974 23.8177C22.3034 23.8003 21.592 24.4293 20.8567 25.6851C20.6008 26.1145 20.154 26.2316 19.5099 26.0408C19.4101 26.0082 19.3038 25.9258 19.1867 25.7935C18.8809 25.4552 18.8484 25.0908 19.087 24.7026C20.3015 22.7181 21.5985 21.7942 22.9887 21.9178H22.9909Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0813 21.9175C38.5778 21.8091 39.916 22.8935 41.1067 25.1664C41.3041 25.546 41.0416 26.0101 40.5862 26.0839L40.2804 26.1338C39.6926 26.2248 39.2393 25.9776 38.9335 25.3725C38.4304 24.3727 37.8014 23.8521 37.0575 23.8261C36.3136 23.8348 35.6694 24.3293 35.1402 25.3226C34.8171 25.9169 34.3638 26.1576 33.776 26.0492L33.4702 25.9906C33.0147 25.9082 32.7588 25.4376 32.9735 25.0645C34.2141 22.8241 35.5848 21.7744 37.0813 21.9154V21.9175Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0247 39.0408C33.5295 39.0321 36.6614 37.0563 38.0581 33.9743C38.2403 33.5861 38.6936 33.4213 39.0167 33.636L39.611 34.0155C39.9168 34.2129 40.0317 34.5946 39.8756 34.9004C39.2401 36.1063 38.455 37.1322 37.5202 37.9824C35.2972 39.9907 32.8008 40.9906 30.0334 40.9992C27.2638 41.0079 24.7696 40.0081 22.5292 38.0149C21.5944 37.1712 20.8028 36.1475 20.1651 34.9395C20.0003 34.6423 20.1152 34.2541 20.421 34.0546L21.0153 33.675C21.3385 33.4603 21.7918 33.6165 21.9739 34.0047C23.388 37.0866 26.5285 39.0451 30.0225 39.0386L30.0247 39.0408Z",
    fill: "#1E1E1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_34296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxed);
export default __webpack_public_path__ + "static/media/relaxed.cb6f82fa9965fbe45675c914553c355b.svg";
export { ForwardRef as ReactComponent };